"use client";

export const useScroll = () => {
  const allowScroll = () => (window.document.body.style.overflow = "unset");

  const disableScroll = () => (window.document.body.style.overflow = "hidden");

  return { allowScroll, disableScroll };
};
